var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 25.522688,6.929935 v 19.1401 L 6.335241,26.117382 6.382588,6.882588 Z M 25.3333,4.5 H 6.66667 C 5.2,4.5 4,5.7 4,7.16667 V 25.8333 C 4,27.3 5.2,28.5 6.66667,28.5 H 25.3333 C 26.8,28.5 28,27.3 28,25.8333 V 7.16667 C 28,5.7 26.8,4.5 25.3333,4.5 Z M 24,8.8043009 h -5.75405 v 4.3843001 h -3.44 l 0.02785,4.444983 h -3.44 l -0.02785,4.402583 H 8 V 24.5 h 5.8933 v -4.44 h 3.44 v -4.44 h 3.44 V 11.1667 H 24 Z",
    fill: "#000000",
    id: "path2"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "none",
      strokeWidth: 1.57134,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      paintOrder: "fill markers stroke"
    },
    id: "rect2",
    width: 20.82201,
    height: 20.36936,
    x: 5.9111443,
    y: 6.3828006,
    ry: 6.1399341,
    rx: 0
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStair);
export default __webpack_public_path__ + "static/media/stair.abc950c566202475f09898f0a1a6e841.svg";
export { ForwardRef as ReactComponent };